import { getActiveLanguage, getTranslate, setActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { serviceLocator } from '../infrastructure/ServiceLocator';

export const withLocale = connect(
  (state) => {
    const { locale, domain } = state;
    const currentLanguage = getActiveLanguage(state.locale).code;
    return {
      translate: getTranslate(locale),
      currentLanguage,
      locale,
      localMoment: (date) => moment(date).locale(currentLanguage),
      domain,
    };
  },
  (dispatch) => ({
    changeLang: function (lang) {
      let api = serviceLocator.userApi;
      api.setLang(lang);
      dispatch(setActiveLanguage(lang));
    },
  })
);
